import PropTypes from "prop-types";
import ProductLocationForm from "./ProductLocationForm";

export default function Screen5({
  onNext,
  onReset,
  country_iso2_code,
  siteId,
  brandId,
}) {
  return (
    <>
      <div id="bf-chat-window-screen-5">
        <ProductLocationForm
          onSubmit={onNext}
          onReset={onReset}
          country_iso2_code={country_iso2_code}
          siteId={siteId}
          brandId={brandId}
        />
      </div>
    </>
  );
}

Screen5.propTypes = {
  onNext: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  country_iso2_code: PropTypes.string.isRequired,
  brand_id: PropTypes.string.isRequired,
};
